import { createFileRoute } from "@tanstack/react-router";
import Loner from "@/pages/Loner";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildPageSchema, buildSeoHead, buildServiceSchema, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/loneadministration")({
  head: () =>
    buildSeoHead(
      publicPageSeo.loneadministration,
      [
        buildPageSchema(publicPageSeo.loneadministration, "WebPage"),
        buildServiceSchema(publicPageSeo.loneadministration, "Löneadministration", [
          "Löneutbetalningar",
          "AGI",
          "Semester och frånvaro",
          "Lönebackup",
        ]),
        buildBreadcrumbSchema(getBreadcrumbTrail("/loneadministration") ?? []),
      ],
    ),
  component: Loner,
});
